<template>
  <v-app class="app">
    <AppBarAndNavigationDrawer />

    <v-main>
      <router-view />
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Footer from '@/componentes/Footer'

import AppBarAndNavigationDrawer from '../components/AppBarAndNavigationDrawer'

export default {
  name: 'CallCenterLayout',
  components: { AppBarAndNavigationDrawer, Footer },
}
</script>

<style scoped>
.app {
  background-color: var(--v-background-base);
}
</style>
